import { Canvas } from '@react-three/fiber';
import { Suspense, useCallback } from 'react';
import { useKeyboardControls } from '../hooks/useKeyboardControls';
import { BeeHiveScene } from '../rendering/BeeHiveScene';
import { useGameStore } from '../simulation/store';

export function GameViewport() {
  useKeyboardControls();
  const zoomCamera = useGameStore((state) => state.zoomCamera);
  const completeDrag = useGameStore((state) => state.completeDrag);

  const handleWheel = useCallback(
    (event: React.WheelEvent<HTMLDivElement>) => {
      zoomCamera(event.deltaY > 0 ? -2 : 2);
    },
    [zoomCamera]
  );

  return (
    <div
      className="absolute inset-0"
      onWheel={handleWheel}
      onPointerUp={() => completeDrag()}
    >
      <Canvas
        orthographic
        shadows
        camera={{ position: [8, 18, 8], zoom: 28, near: 0.1, far: 1000 }}
        gl={{ antialias: true, powerPreference: 'high-performance' }}
      >
        <Suspense fallback={null}>
          <BeeHiveScene />
        </Suspense>
      </Canvas>
    </div>
  );
}
